import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './user';
import authReducer from './auth';
import configurationReducer from './configuration';
import legalReducer from './legal';
import systemReducer from './system';
import patientReducer from './patient';
import configurationApi from '@/services/configuration.api';
import authApi from './../services/auth.api';
import ssoApi from './../services/sso.api';
import clinicianApi from '@/services/clinician.api';
import patientApi from '@/services/patient.api';
import measurementApi from '@/services/measurement.api';
import baseApi from '@/services/base.api';
import patientMeasurementContextReducer from './patient-measurement-context';
import userApi from '@/services/user.api';
import organizationApi from '@/services/organization.api';
import legalApi from '@/services/legal.api';
import transferApi from '@/services/transfer.api';

const rootReducer = combineReducers({
  system: systemReducer,
  user: userReducer,
  auth: authReducer,
  configuration: configurationReducer,
  legal: legalReducer,
  patient: patientReducer,
  patientMeasurementContext: patientMeasurementContextReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [configurationApi.reducerPath]: configurationApi.reducer,
  [patientApi.reducerPath]: patientApi.reducer,
  [clinicianApi.reducerPath]: clinicianApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [measurementApi.reducerPath]: measurementApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [ssoApi.reducerPath]: ssoApi.reducer,
  [organizationApi.reducerPath]: organizationApi.reducer,
  [legalApi.reducerPath]: legalApi.reducer,
  [transferApi.reducerPath]: transferApi.reducer,
});

export const middlewares = [
  baseApi.middleware,
  configurationApi.middleware,
  patientApi.middleware,
  clinicianApi.middleware,
  measurementApi.middleware,
  authApi.middleware,
  userApi.middleware,
  ssoApi.middleware,
  organizationApi.middleware,
  legalApi.middleware,
  transferApi.middleware,
];

export type RootState = ReturnType<typeof rootReducer>;

declare module 'react-redux' {
  type DefaultRootState = {} & RootState;
}

export default rootReducer;
